import { render } from "./CreateGatepass.vue?vue&type=template&id=28a37f10&scoped=true"
import script from "./CreateGatepass.vue?vue&type=script&lang=js"
export * from "./CreateGatepass.vue?vue&type=script&lang=js"

import "./CreateGatepass.vue?vue&type=style&index=0&id=28a37f10&scoped=true&lang=css"
import "./CreateGatepass.vue?vue&type=style&index=1&id=28a37f10&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a37f10"]])

export default __exports__